import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Logo from '../images/Transmit@2x.png';

import styles from './composer/site-components/site.module.css';
import RequestDemoModal from './request-demo-modal';

const Footer = () => {
  const [demoOpen, setDemoOpen] = useState(false);
  const handleDemoOpen = (e) => {
    e.preventDefault();
    setDemoOpen(true);
  };
  const handleDemoClose = () => {
    setDemoOpen(false);
  };

  return (
    <div className={styles.greyBg}>
      <div className={classNames(styles.footer, styles.footerGrid)}>
        <div className={styles.footerCoryright}>
          <Link to="/" style={{ height: 24 }}>
            <img height="24" src={Logo} alt="Transmit" />
          </Link>
          <div>© {new Date().getFullYear()} Transmit</div>
          <div className={styles.f1} />
          <a href="https://twitter.com/Transmit" aria-label="Twitter">
            <TwitterIcon />
          </a>
          <a href="https://www.instagram.com/transmit.live/" aria-label="Instagram">
            <InstagramIcon />
          </a>
          <a href="https://www.linkedin.com/company/transmitlive/" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
        </div>
        <div className={styles.footerLinkGrid}>
          <div className={styles.footerLinks}>
            <b>Products</b>
            <Link to="/stream-composer">Stream Composer</Link>
            <Link to="/reach-extension">Reach Extension</Link>
            <Link to="/creative-studio">Creative Studio</Link>
          </div>
          <div className={styles.footerLinks}>
            <b>Contact</b>
            <Link onClick={handleDemoOpen} to="#">
              Request a Demo
            </Link>
            <a href="mailto:finance@transmit.live">Contact Us</a>
          </div>
          <div className={styles.footerLinks}>
            <b>Policies</b>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/security">Security Policy</Link>
          </div>
        </div>
        <div />
        <div className={classNames(styles.footerLinkGrid, styles.footerGridCenter)}>
          <img src="https://dxgcj7vu1u7nu.cloudfront.net/web-assets/iab.svg" alt="iab Member" title="iab Member" />
          <img
            src="https://dxgcj7vu1u7nu.cloudfront.net/web-assets/tag.svg"
            alt="Tag Registered"
            title="Tag Registered"
          />
          <img
            width="103px"
            src="https://dxgcj7vu1u7nu.cloudfront.net/web-assets/fast-company@2x.png"
            alt="Fast Company Most Innovative Companies 2022"
            title="Fast Company Most Innovative Companies 2022"
          />
        </div>
      </div>
      <RequestDemoModal open={demoOpen} handleClose={handleDemoClose} />
    </div>
  );
};

Footer.defaultProps = {};

Footer.propTypes = {};

export default Footer;
